import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import { ContactPage, PrivacyPage, TermsPage } from "@/pages/StaticPages";
import { initConsentScripts, initScrollDepth, trackEvent } from "@/lib/analytics";

const ScrollManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
    trackEvent("page_view", { path: pathname });
  }, [pathname]);

  return null;
};

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let lenis = null;
    let rafId;

    if (!prefersReduced) {
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      window.__lenis = lenis;
      const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    }

    initConsentScripts();
    const cleanupScrollDepth = initScrollDepth();

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      lenis?.destroy();
      window.__lenis = null;
      cleanupScrollDepth?.();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/obchodni-podminky" element={<TermsPage />} />
          <Route path="/ochrana-osobnich-udaju" element={<PrivacyPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
